<script setup lang="ts">
import { computed, ref } from 'vue'
import { AccountListItem } from 'wepin-vue-component'
import { defaultCoinIcon } from '@/const'
import { useLoadingsStore, useLocaleStore } from '@/stores'
import { formatDecimal } from '@/utils'

const props = withDefaults(
  defineProps<{
    ticker: string
    symbol: string
    name: string
    amount: string
    value: string
    supportNft?: boolean
    currentValue?: string
    unit: string
    dailyRange?: string
    type: 'card' | 'list' | 'list-shortform' | 'list-table'
    tickerSrc: string
    evalBalanceWidth: number | '52%'
    networkSrc?: string
    isChild?: boolean
    isMobile?: boolean
    loading?: boolean
    isActive?: boolean
  }>(),
  {
    currentValue: undefined,
    dailyRange: undefined,
    isChild: undefined,
    isMobile: undefined,
    supportNft: true,
    isActive: false,
  },
)
const emits = defineEmits(['click:item'])

const localeStore = useLocaleStore()
const loadingStore = useLoadingsStore()

const formattedAmount = computed(() => {
  return localeStore.applyDigitRule(props.amount, { maximumFractionDigits: 4 })
})
const formattedValue = computed(() => {
  return localeStore.applyLocaleCurrencyDigitRule(props.value)
})
const formattedCurrentValue = computed(() => {
  if (props.currentValue) {
    return localeStore.applyLocaleCurrencyDigitRule(props.currentValue)
  }
  return props.currentValue
})

const getTickerUrl = computed(() => {
  if (isErrorTokenIcon.value) {
    return defaultCoinIcon
  }
  return props.tickerSrc
})
const getNetworkUrl = computed(() => {
  if (isErrorNetworkIcon.value) {
    return defaultCoinIcon
  }
  return props.networkSrc
})

const isErrorTokenIcon = ref(false)
const onErrorTokenIcon = () => {
  isErrorTokenIcon.value = true
}
const isErrorNetworkIcon = ref(false)
const onErrorNetworkIcon = () => {
  isErrorNetworkIcon.value = true
}
const onClickAccountItem = () => {
  emits('click:item')
}
</script>

<template>
  <AccountListItem
    v-if="loading || loadingStore.localeLoading"
    ticker=""
    symbol=""
    name=""
    amount=""
    value=""
    current-value=""
    unit=""
    daily-range=""
    :type="type"
    ticker-src=""
    network-src=""
    :eval-balance-width="
      evalBalanceWidth === '52%' ? evalBalanceWidth : evalBalanceWidth + 'px'
    "
    :is-child="isChild"
    :is-mobile="isMobile"
    :loading="true"
  />
  <AccountListItem
    v-else
    :ticker="ticker"
    :symbol="symbol"
    :name="name"
    :amount="formatDecimal(formattedAmount, 4)"
    :value="formattedValue ?? '0'"
    :support-nft="supportNft"
    :current-value="formattedCurrentValue"
    :unit="unit"
    :daily-range="dailyRange"
    :type="type"
    :ticker-src="getTickerUrl"
    :network-src="getNetworkUrl"
    :eval-balance-width="
      evalBalanceWidth === '52%' ? evalBalanceWidth : evalBalanceWidth + 'px'
    "
    :is-child="isChild"
    :is-mobile="isMobile"
    :is-active="isActive"
    @error:load-token-icon="onErrorTokenIcon"
    @error:load-network-icon="onErrorNetworkIcon"
    @click="onClickAccountItem"
  />
</template>
